
<div class="row animated fadeInRight mb-4">
    <div class="col-md-3">
        <button
            class="{{diccionarioModulo.button.buttonsCss.successOutline}}"
            (click)="requestUsbPrinter()"
        >Vincular Impresora</button>
        <span class="badge rounded-pill" [class.bg-danger]="!printerStatus" [class.bg-success]="printerStatus">{{printerStatus ? 'Conectado' : 'Sin conexión'}}</span>
    </div>
    <div class="col-md-3">
        <h5><b>Comedor:</b> {{comedorTipo}} </h5>
    </div>
    <div class="col-md-4"> 
        <h5><b>Turno:</b> {{ tipoComida.turno }} </h5>
    </div>
    <div class="col-md-2">
        <h5><b>Secuencia:</b> {{ tipoComida.secuencia }} </h5>
    </div>
</div>
<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="'Buscar Colaborador'"></app-lfsa-card>
<ng-template #enviarTemplate>
    <form [formGroup]="formulario" novalidate class="form-group">
        <div class="row">
            <div class="form-group col-md-6">
                <app-lfsa-combo-box [opcion]="'tipo'" [idOpcion]="'id'" [comboBox]="cmbTipo" formControlName="tipo"
                    [control]="formulario.get('tipo')" [label]="'Tipo Lectura*'" [id]="'tipo'">
                </app-lfsa-combo-box>
            </div>

            <div class="row col-md-6" *ngIf="aplicaJugo">
                <div class="col-sm">
                    <app-lfsa-input #jugoExtra (keyup)="onKeydown($event)" [label]="'Jugo Extra*'" [control]="formulario.get('jugoExtra')" 
                                    formControlName="jugoExtra" [type]="'number'" [id]="'jugoExtra'" [isReadOnly]="true">
                    </app-lfsa-input>
                </div>
                <div class="col-sm">
                    <label for="aplicaJugo">Activar Jugo Extra</label>
                    <div class="form-check">
                        <input class="form-check-input" formControlName="aplicaJugo" id="aplicaJugo" type="checkbox">
                        <label class="form-check-label" for="aplicaJugo">{{this.formulario.get('aplicaJugo').value ? 'Si' : 'No'}}</label>
                    </div>
                </div>             
            </div>
        </div>

        <div class="row">
            <div class="form-group col-md-6">
                <app-lfsa-input #tarjeta (keyup)="onKeydown($event)" [control]="formulario.get('tarjeta')"
                    [placeholder]="'tarjeta '" formControlName="tarjeta" [label]="'Tarjeta*'" [type]="'number'" (keyup.Space)= "doSomething()"
                    [id]="'tarjeta'">
                </app-lfsa-input>
            </div>
            <div class="form-group col-md-6">
                <label>&nbsp;</label>
                <button *ngIf="!loading" [disabled]="formulario.invalid" class="{{diccionarioModulo.button.buttonsCss.success}}" (click)="buscarServicio()">Enviar</button>
                <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
            </div>
        </div>
    </form>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateDatos" [titulo]="'Datos Colaborador'"></app-lfsa-card>
<ng-template #enviarTemplateDatos>

    <div class="row col-12">
        <div class="col-md-6">
            <h5><b>Nombres :</b> {{ dataUsuario.nombre }}</h5>
        </div>
        <div class="col-md-6">
            <h5><b>Apellidos :</b> {{ dataUsuario.apellido }}</h5>
        </div>
    </div>
    <hr>
    <div class="row col-12">
        <div class="col-md-6">
            <h5><b>Cedula :</b> {{ dataUsuario.cedula }}</h5>
        </div>
        <div class="col-md-6">
            <h5><b>Cargo :</b> {{ dataUsuario.cargo }}</h5>
        </div>
    </div>
    <hr>
    <div class="row col-12">
        <div class="col-md-6">
            <h5><b>Departamento :</b> {{ dataUsuario.departamento }}</h5>
        </div>
        <div class="col-md-6">
            <h5><b>Menú :</b> {{ tipoComida.menu }}</h5>
        </div>
    </div>
    <hr>

    <div class="row" *ngif = 'false'> <!-- DESCONTINUADO //Feat: T30882 AppComedor Programa nutricional-->
        <div class="col-md-6">
            <label>&nbsp;</label>
            <button [disabled]="formulario.invalid" class="{{diccionarioModulo.button.buttonsCss.success}}"
                (click)="enviarMarcacion('CON VALE')">Con Vale</button>
        </div>
        <div class="col-md-6">
            <label>&nbsp;</label>
            <button [disabled]="formulario.invalid" class="{{diccionarioModulo.button.buttonsCss.primary}}"
                (click)="enviarMarcacion('SIN VALE')">Sin Vale</button>
        </div>
    </div>
</ng-template>